import { Container } from 'components/atoms';
import { ReactNode } from 'react';
import './HeaderStatusWrapper.scss';

interface HeaderStatusWrapper {
  title: ReactNode;
  children?: ReactNode;
  headerContent?: ReactNode;

  maxWidth?: number;
}

const HeaderStatusWrapper = ({ title, children, headerContent }: HeaderStatusWrapper) => {
  return (
    <Container className="HeaderStatusWrapper self-start w-full">
      <Container.Header title={title}>{headerContent}</Container.Header>

      {children && (
        <Container.Content className="HeaderStatusWrapper-content">
          {children && <div className="HeaderStatusWrapper-children">{children}</div>}
        </Container.Content>
      )}
    </Container>
  );
};

export default HeaderStatusWrapper;
